export type HospitalDemoPlan = 'starter' | 'pro' | 'enterprise';

export const DEMO_TENANT_BY_PLAN: Record<HospitalDemoPlan, string> = {
  starter: 'hosp-demo-starter',
  pro: 'hosp-demo-pro',
  enterprise: 'hosp-demo-enterprise',
};

export const DEMO_PLAN_OPTIONS: { slug: HospitalDemoPlan; label: string; emoji: string }[] = [
  { slug: 'starter', label: 'Starter · 10 camas', emoji: '🏥' },
  { slug: 'pro', label: 'Pro · hospital mediano', emoji: '🏨' },
  { slug: 'enterprise', label: 'Enterprise · red hospitalaria', emoji: '🌐' },
];

export function planFromDemoSlug(slug: string | null | undefined): HospitalDemoPlan | null {
  if (slug === 'starter' || slug === 'pro' || slug === 'enterprise') return slug;
  return null;
}

export function demoTenantForPlan(plan: HospitalDemoPlan | string | null | undefined): string {
  if (plan && plan in DEMO_TENANT_BY_PLAN) return DEMO_TENANT_BY_PLAN[plan as HospitalDemoPlan];
  return DEMO_TENANT_BY_PLAN.pro;
}

export function demoAdminUser(tenantId: string): string {
  return `${tenantId}@toscanasystems.com`;
}

export function isDemoTenant(tenantId: string | null | undefined): boolean {
  return !!tenantId && tenantId.startsWith('hosp-demo-');
}

export function resolveDemoPilotCredentials(defaults: {
  tenantId: string;
  usuario: string;
}): { tenantId: string; usuario: string } {
  try {
    const tid = sessionStorage.getItem('toscana.demo.tenant');
    if (tid && isDemoTenant(tid)) {
      return { tenantId: tid, usuario: demoAdminUser(tid) };
    }
  } catch { /* ignore */ }
  return defaults;
}
